import { HttpErrorResponse } from "@angular/common/http";

import { GroupModel } from "@core/models/groups.model";
import { RightModel } from "@core/models/rights.model";
import * as GroupsActions from "@features/groups/store/groups.actions";
import { createReducer, on } from "@ngrx/store";
// import { PendingIban } from "@core/models/pending-iban.model";
// import { PendingNav } from "@core/models/pending-nav.model";
// import { ProductVersions } from "@core/models/product-versions.model";
// import { ExtendedGfhAccount } from "@core/models/extended-gfh-account.model";

export interface GroupsState {
  // pendingNavList: Array<PendingNav>;
  // productVersionList: Array<ExtendedGfhAccount>;
  // selfApprovalList: Array<PendingIban>;
  // approvalList: Array<PendingIban>;
  // lastSevenDaysList: Array<PendingIban>;
  // productVersions: ProductVersions;
  groupsLoading: boolean;
  rightsLoading: boolean;
  groupsList: Array<GroupModel>;
  rightsList: Array<RightModel>;
  // selfApprovalLoading: boolean;
  // approvalLoading: boolean;
  // lastSevenDaysLoading: boolean;
  error: HttpErrorResponse | null;
}

const initialState: GroupsState = {
  // pendingNavList: [],
  // productVersionList: [],
  // selfApprovalList: [],
  // approvalList: [],
  // lastSevenDaysList: [],
  // productVersions: new ProductVersions(),
  groupsLoading: false,
  rightsLoading: false,
  groupsList: [],
  rightsList: [],
  // selfApprovalLoading: false,
  // approvalLoading: false,
  // lastSevenDaysLoading: false,
  error: null,
};

export const GROUPS_REDUCER = createReducer(
  initialState,
  on(GroupsActions.GROUPS_ACTION_FAILURE, (state, action): GroupsState => {
    return {
      ...state,
      error: action.error,
    };
  }),
  on(
    GroupsActions.SET_GROUPS_LOADING,
    (state: GroupsState, action: { loading: boolean }): GroupsState => {
      return {
        ...state,
        groupsLoading: action.loading,
      };
    }
  ),
  on(
    GroupsActions.SET_RIGHTS_LOADING,
    (state: GroupsState, action: { loading: boolean }): GroupsState => {
      return {
        ...state,
        rightsLoading: action.loading,
      };
    }
  ),
  on(
    GroupsActions.SET_GROUPS_LIST,
    (
      state: GroupsState,
      action: { groupsList: Array<GroupModel> }
    ): GroupsState => {
      return {
        ...state,
        groupsList: action.groupsList,
      };
    }
  ),
  on(
    GroupsActions.SET_RIGHTS_LIST,
    (
      state: GroupsState,
      action: { rightsList: Array<RightModel> }
    ): GroupsState => {
      return {
        ...state,
        rightsList: action.rightsList,
      };
    }
  )
  // on(
  //   GroupsActions.SET_PENDING_NAV,
  //   (
  //     state: GroupsState,
  //     action: {
  //       pendingNavList: Array<PendingNav>;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       pendingNavList: action.pendingNavList,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_PRODUCT_VERSION_CHANGED_LIST,
  //   (
  //     state: GroupsState,
  //     action: {
  //       productVersionList: Array<ExtendedGfhAccount>;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       productVersionList: action.productVersionList,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_SELF_APPROVAL_TABLE,
  //   (
  //     state: GroupsState,
  //     action: {
  //       selfApprovalList: Array<PendingIban>;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       selfApprovalList: action.selfApprovalList,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_SELF_APPROVAL_TABLE_LOADING,
  //   (
  //     state: GroupsState,
  //     action: {
  //       selfApprovalLoading: boolean;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       selfApprovalLoading: action.selfApprovalLoading,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_APPROVAL_TABLE,
  //   (
  //     state: GroupsState,
  //     action: {
  //       approvalList: Array<PendingIban>;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       approvalList: action.approvalList,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_APPROVAL_TABLE_LOADING,
  //   (
  //     state: GroupsState,
  //     action: {
  //       approvalLoading: boolean;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       approvalLoading: action.approvalLoading,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_LAST_SEVEN_DAYS_APPROVED_TABLE,
  //   (
  //     state: GroupsState,
  //     action: {
  //       lastSevenDaysList: Array<PendingIban>;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       lastSevenDaysList: action.lastSevenDaysList,
  //     };
  //   }
  // ),
  // on(
  //   GroupsActions.SET_LAST_SEVEN_DAYS_APPROVED_TABLE_LOADING,
  //   (
  //     state: GroupsState,
  //     action: {
  //       lastSevenDaysLoading: boolean;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       lastSevenDaysLoading: action.lastSevenDaysLoading,
  //     };
  //   }
  // )
  // on(
  //   GroupsActions.SET_PRODUCT_VERSIONS,
  //   (
  //     state: GroupsState,
  //     action: {
  //       productVersions: ProductVersions;
  //     }
  //   ): GroupsState => {
  //     return {
  //       ...state,
  //       productVersions: action.productVersions,
  //     };
  //   }
  // )
);
